import { createPortal } from 'react-dom';
import { useI18n } from '../i18n/context.js';

export type PagerPage = 'left' | 'center' | 'right';

export interface PagerDotsProps {
  page: PagerPage;
  onSelect: (page: PagerPage) => void;
}

const PAGES: PagerPage[] = ['left', 'center', 'right'];

/** Liquid-glass three-dot switcher between the sidebar, the chat and personal chats. */
export function PagerDots({ page, onSelect }: PagerDotsProps) {
  const { t } = useI18n();
  const labels: Record<PagerPage, string> = {
    left: t('sidebar.title'),
    center: t('pager.chat'),
    right: t('directChat.open'),
  };
  return createPortal(
    <nav className="pager-dots" aria-label={t('pager.label')}>
      <div className="pager-dots-pill">
        {PAGES.map((item) => (
          <button
            key={item}
            type="button"
            className="pager-dot"
            aria-label={labels[item]}
            aria-current={page === item}
            onClick={() => onSelect(item)}
          />
        ))}
      </div>
    </nav>,
    document.body,
  );
}
